// Used across ALL components — import from here, never hardcode colors

export const STATUS_COLORS = {
  'Pending':     { bg: 'bg-gray-100',   text: 'text-gray-700',   border: 'border-gray-300'   },
  'In Progress': { bg: 'bg-blue-100',   text: 'text-blue-700',   border: 'border-blue-300'   },
  'Ready':       { bg: 'bg-green-100',  text: 'text-green-700',  border: 'border-green-300'  },
  'Delivered':   { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-300' },
  'Cancelled':   { bg: 'bg-gray-200',   text: 'text-gray-500',   border: 'border-gray-400'   },
};

export const PRIORITY_COLORS = {
  'Normal': { bg: 'bg-green-100', text: 'text-green-700' },
  'Urgent': { bg: 'bg-red-100',   text: 'text-red-700'   },
};

// Overdue = red regardless of status
export const OVERDUE_COLORS = {
  bg: 'bg-red-100', text: 'text-red-700', border: 'border-red-400'
};

// Due today = yellow
export const DUE_TODAY_COLORS = {
  bg: 'bg-yellow-100', text: 'text-yellow-700', border: 'border-yellow-400'
};

export function getOrderColors(order) {
  if (order.is_overdue) return OVERDUE_COLORS;
  
  // Create a local YYYY-MM-DD string that ignores timezone shifts
  const today = new Date().toLocaleDateString('en-CA'); 
  if (order.target_date === today) return DUE_TODAY_COLORS;
  
  return STATUS_COLORS[order.status] || STATUS_COLORS['Pending'];
}